import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AlertController, LoadingController, Platform, ToastController } from '@ionic/angular';
import { ValueAccessor } from '@ionic/angular/directives/control-value-accessors/value-accessor';
import { TranslateService } from '@ngx-translate/core';
import { LocalDataSource } from 'src/app/ng2-smart-table/lib/data-source/local/local.data-source';
import { Api } from 'src/app/providers/api/api';
import { ConfigurationService } from 'src/app/providers/configuration.service';


@Component({
  selector: 'app-neat-cmp',
  templateUrl: './neat-cmp.component.html',
  styleUrls: ['./neat-cmp.component.scss']
})
export class NeatCmpComponent {

  @Input() action: string;
  @Input() disabled = false;
  @Input() managementData: any;
  settings: any;
  isCore = false;
  tableData: LocalDataSource = new LocalDataSource();
  testDataNeatLogin: { email: string; password: string; totpcode: string; } = { email: '', password: '', totpcode: '' };

  constructor(private alertController: AlertController, private translate:TranslateService, private api:Api, private plf: Platform, 
    private configService: ConfigurationService, private toastController: ToastController, private loadingController: LoadingController) { 

    this.isCore = this.plf.is('desktop'); // TODOALEX

    this.settings = {
      mode: 'external',
      actions: {
        edit: false,
        delete: false,
        add: false
      },
      columns: {
        'technical_status_last': {
          title: "Letzte Prüfung",
          valuePrepareFunction: (date) => {
            return new DatePipe('de').transform(date, 'dd.MM.yyyy HH:mm:ss');
          }
        },
        'group_name': {
          title: "Kunde"
        },
        'serial_number': {
          title: "Seriennummer"
        },
        'technical_status': {
          title: "Status",
          type: 'html',
          valuePrepareFunction: (status) => {
            switch(status) {
              case 0:
                return "<div class='success'>keine Störung</div>";
              case 90:
                return "<div class='danger'>Testalarm fehlgeschlagen</div>";
              case 110:            
                return "<div class='danger'>Kein Kontakt zum Portal</div>";
              case 120:
                return "<div class='danger'>Anwenderalarm fehlgeschlagen</div>";
            }
          }
        }
      },
      pager: {
        perPage: 5
      },
      edit: {
        inputClass: 'ion-button'
      },
  
      filter: null,
      noDataMessage: "Keine Daten vorhanden"
    };
  } 


  // {
  //   "operational_status_last": null,
  //   "parent_group_name": "PF IT Consult",
  //   "alarm_code": "4005",
  //   "id": 145322,
  //   "user_state": "[H]",
  //   "operational_status": 0,
  //   "note": "",
  //   "serial_number": "10146564",
  //   "model_id": 3001,
  //   "enduser_id": 83624,
  //   "technical_status": 120,
  //   "sell_date": "2019-11-18",
  //   "group_name": "Geschwister Pape",
  //   "user_alarm_last": "2023-02-16 13:20:49",
  //   "enduser_name": "Konrad Mai",
  //   "group_id": 2233,
  //   "product_type": 3,
  //   "carrier_type": "[CGSM]",
  //   "technical_status_last": "2023-02-17 09:50:37",
  //   "group_path": ":1:263:162:347:2562:1804:2233:"
  // },



  async presentLoginNeat() {
    let cookieIsSet = false;
    const alert = await this.alertController.create({
      header: 'CMP - '+this.translate.instant('LOGIN'),
      backdropDismiss: false,
      inputs: [
        {
          name: 'email',
          type: 'email',
          placeholder: this.translate.instant('EMAIL'),
          value: this.testDataNeatLogin.email || ''
        },
        {
          name: 'password',
          type: 'password',
          placeholder: this.translate.instant('PASSWORD'),
          value: this.testDataNeatLogin.password || ''
        },
        {
          name: 'totpcode',
          type: 'text',
          placeholder: this.translate.instant('TOTP_CODE'),
          value: this.testDataNeatLogin.totpcode || ''
        }
      ],
      buttons: [
        {
          text: this.translate.instant('Cancel'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
            return false;
          }
        }, {
          text: this.translate.instant('LOGIN'),
          handler: (data) => {
            if(!data.email || !data.password || !data.totpcode) {
              this.alertController.create({
                header: this.translate.instant('ERROR'),
                message: this.translate.instant('Message.NotAllFieldsFilled'),
                buttons: [this.translate.instant('CLOSE_BUTTON')]
              }).then(alert => alert.present());
              return false;
            }

            this.api.post('neatLogin', {
              body: {
                "email": data.email,
                "password": data.password,
                "totpcode": data.totpcode
              }
            }).subscribe({next:async (data:any, ) => {
              if(data.data.success) {
                const cookie = data.data.data[0];
                localStorage.setItem('neatCookie', JSON.stringify(cookie));
                cookieIsSet = true;
                return true;
              } else {
                await this.alertController.create({
                  header: this.translate.instant('Message.ERROR'),
                  message: this.translate.instant('Message.LoginFailed'),
                  buttons: [this.translate.instant('CLOSE_BUTTON')]
                });
                await alert.present();
                await alert.onDidDismiss();
                return false;
              }
            }, error: (err:any) => {
              console.log("error Login" , err);
              return false;
            }});
          }
        }
      ]
    });

    await alert.present();
    const {data} = await alert.onDidDismiss();
    data.cookieIsSet = cookieIsSet;
    return data;
  }

  async getDeviceStatus() {
    // öffne ein Fenster mit der Eingabe von Username und Passwort

    let result = false;


    const neatCookie = JSON.parse(localStorage.getItem('neatCookie'));
    if(!neatCookie) {
;      const data = await this.presentLoginNeat();
      if(data.values.email && data.values.password && data.values.totpcode) {
        return await this.getDeviceStatus();
      }
    } else {
      this.api.post('neatStatus', {
        body: {
          "cookie": neatCookie
        }
      }).subscribe({next: async (data:any) => {
        if(data.data.data === false && data.data.success === true) {
          const res = await this.presentLoginNeat();
          if(res.values.email && res.values.password && res.values.totpcode) {
            await this.getDeviceStatus();
          }
          return false;
        }
        result = true;
        this.tableData.load(data.data.data.content);
      }, error: async (err:any) => {
        const res = await this.presentLoginNeat();
        if(res === true) {
          await this.getDeviceStatus();
        }
      }});
    }    
  }

  rowSelect(event) {
    console.log(event);
  }

  async setDeviceConfig() {

    const loading = await this.loadingController.create({
      message: this.translate.instant('Loading.PleaseWait')
    });
    await loading.present();

    const deviceConfig:any = await this.configService.getValue('deviceConfig');

    if(deviceConfig && this.managementData) {

      if(!this.managementData.serienNr || !this.managementData.transmitterId || !this.managementData.patientName) {
        this.alertController.create({
          header: this.translate.instant('ERROR'),
          message: this.translate.instant('Message.NotAllFieldsFilled'),
          buttons: [this.translate.instant('CLOSE_BUTTON')]
        }).then(alert => alert.present());
        await loading.dismiss();
        return false;
      }

      const neatCookie = JSON.parse(localStorage.getItem('neatCookie'));
      if(!neatCookie) {
        await this.presentLoginNeat();
        this.api.post('neatInstallation', {
          body: {
            "cookie": neatCookie,
            "serialNumber": this.managementData.serienNr,
	          "prom": this.managementData.transmitterId,
	          "userName": this.managementData.patientName,
            "sequences" : deviceConfig.sequences,
            "steps": deviceConfig.steps
          }
        }).subscribe({next: async (data:any) => {
          if(data.data.data === false && data.data.success === true) {
            await loading.dismiss();
          } else if(data.data.success) {
            this.toastController.create({
              message: this.translate.instant('Message.DeviceConfigSet'),
              duration: 5000,
              position: 'middle',
              color: 'dark'
            }).then(toast => toast.present());
            await loading.dismiss();
          }

          if(data.data.data === "Session abgelaufen" && data.data.success === false) {
            await loading.dismiss();
            await this.presentLoginNeat();
            await this.setDeviceConfig();
          }

        }, error: async (err:any) => {
          await loading.dismiss();
          console.log(err);
        }});
        return false;
      } else {

          this.api.post('neatInstallation', {
            body: {
              "cookie": neatCookie,
              "serialNumber": this.managementData.serienNr,
              "prom": this.managementData.transmitterId,
              "userName": this.managementData.patientName,
              "sequences" : deviceConfig.sequences,
              "steps": deviceConfig.steps
            }
          }).subscribe({next: async (data:any) => {
            await loading.dismiss();
            if(data.data.data === false && data.data.success === true) {
              await this.presentLoginNeat();
              await this.setDeviceConfig();
            } else if (data.data.success) {
              this.toastController.create({
                message: this.translate.instant('Message.DeviceConfigSet'),
                duration: 5000,
                position: 'middle',
                color: 'dark'
              }).then(toast => toast.present());
            }
          }, error: async (err:any) => {
            await loading.dismiss();
            if(err.message === "Session abgelaufen") {
              await this.presentLoginNeat();
              await this.setDeviceConfig();
            } else if (err.message === "Seriennummer nicht gefunden") { 
              this.alertController.create({
                header: this.translate.instant('ERROR'),
                message: this.translate.instant('Message.SerialNumberNotFound'),
                buttons: [this.translate.instant('CLOSE_BUTTON')]
              }).then(alert => alert.present());

            }
          }});
      }

    } else {
      await loading.dismiss();
    }
  }

  async resetDeviceConfig() {

    const loading = await this.loadingController.create({
      message: this.translate.instant('Loading.PleaseWait')
    });
    await loading.present();

    const deviceConfig:any = await this.configService.getValue('deviceConfig');

    if(deviceConfig && this.managementData) {

      if(!this.managementData.serienNr || !this.managementData.transmitterId || !this.managementData.patientName) {
        this.alertController.create({
          header: this.translate.instant('ERROR'),
          message: this.translate.instant('Message.NotAllFieldsFilled'),
          buttons: [this.translate.instant('CLOSE_BUTTON')]
        }).then(alert => alert.present());
        await loading.dismiss();
        return false;
      }

      const neatCookie = JSON.parse(localStorage.getItem('neatCookie'));
      if(!neatCookie) {
        await this.presentLoginNeat();
        this.api.post('neatDeInstallation', {
          body: {
            "cookie": neatCookie,
            "serialNumber": this.managementData.serienNr
          }
        }).subscribe({next: async (data:any) => {
          if(data.data.data === false && data.data.success === true) {
            await loading.dismiss();
          } else if(data.data.success) {
            this.toastController.create({
              message: this.translate.instant('Message.DeviceConfigReset'),
              duration: 5000,
              position: 'middle',
              color: 'dark'
            }).then(toast => toast.present());
            await loading.dismiss();
          }

          if(data.data.data === "Session abgelaufen" && data.data.success === false) {
            await loading.dismiss();
            await this.presentLoginNeat();
            await this.setDeviceConfig();
          }

        }, error: async (err:any) => {
          await loading.dismiss();
          console.log(err);
        }});
        return false;
      } else {

          this.api.post('neatDeInstallation', {
            body: {
              "cookie": neatCookie,
              "serialNumber": this.managementData.serienNr
            }
          }).subscribe({next: async (data:any) => {
            await loading.dismiss();
            if(data.data.data === false && data.data.success === true) {
              await this.presentLoginNeat();
              await this.setDeviceConfig();
            } else if (data.data.success) {
              this.toastController.create({
                message: this.translate.instant('Message.DeviceConfigReset'),
                duration: 5000,
                position: 'middle',
                color: 'dark'
              }).then(toast => toast.present());
            }
          }, error: async (err:any) => {
            await loading.dismiss();
            if(err.message === "Session abgelaufen") {
              await this.presentLoginNeat();
              await this.setDeviceConfig();
            } else if (err.message === "Seriennummer nicht gefunden") { 
              this.alertController.create({
                header: this.translate.instant('ERROR'),
                message: this.translate.instant('Message.SerialNumberNotFound'),
                buttons: [this.translate.instant('CLOSE_BUTTON')]
              }).then(alert => alert.present());

            }
          }});
      }

    } else {
      await loading.dismiss();
    }
  }

}
